var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _ellipse, _ellipse2, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _rect, _path35, _path36, _path37, _path38, _path39, _path40, _path41;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOcThinking(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1339,
    height: 1163,
    viewBox: "0 0 1339 1163",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1086.94 113.366C1148.19 105.483 1180.61 150.814 1189.16 174.465C1238.11 83.2091 1177.53 30.5289 1117.8 34.741C1055.61 36.5903 1030.57 17.5216 1020.44 0C1017.08 41.0734 1025.68 121.249 1086.94 113.366Z",
    fill: "#BAC3D7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1055.61 107.886C1044.58 128.941 1032.22 164.806 1035.26 197.607M1179.9 204.495L1163.6 226.044C1141.95 261.504 1099.89 269.325 1073.71 257.922C1054.8 247.813 1044.44 233.92 1039.22 217.107",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1184.53 178.644C1187.78 174.445 1194.69 169.209 1196.31 181.858C1197.94 194.507 1186.07 202.093 1179.93 204.305",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1188.73 183.53C1189.94 184.696 1191.49 187.722 1187.96 190.503",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1091.98 210.401C1091.44 213.4 1090.19 215.86 1088.74 217.431C1087.27 219.027 1085.85 219.463 1084.8 219.275C1083.76 219.087 1082.58 218.188 1081.75 216.18C1080.93 214.202 1080.62 211.462 1081.15 208.462C1081.69 205.463 1082.94 203.003 1084.39 201.432C1085.87 199.836 1087.28 199.4 1088.33 199.588C1089.38 199.776 1090.55 200.675 1091.38 202.683C1092.2 204.661 1092.52 207.401 1091.98 210.401Z",
    stroke: "#BAC3D7",
    strokeWidth: 5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1075.5 231.528C1077.62 235.264 1083.82 240.623 1091.64 232.181",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1098.11 144.957C1096.03 151.092 1089.01 164.434 1077.6 168.714",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1090.78 180.217C1090.04 177.037 1084.32 170.73 1077.6 168.714",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1128.94 137.279C1134.09 138.038 1144.82 142.167 1146.52 152.608",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1056.31 134.425C1058.03 130.166 1063.84 122.174 1073.36 124.285",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1071.85,
    cy: 141.271,
    rx: 4.5,
    ry: 6,
    transform: "rotate(10.1503 1071.85 141.271)",
    fill: "#BAC3D7"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1129.9,
    cy: 160.3,
    rx: 5,
    ry: 5.5,
    transform: "rotate(10.1503 1129.9 160.3)",
    fill: "#BAC3D7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1155.22 258.607C1201.51 274.486 1271.44 309.394 1306.84 365.994C1342.24 422.593 1302.6 450.421 1269.65 460.797L1205.63 480.607",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1066.26 254.135L1057.55 284.012M1166.77 223.283L1144.16 287.911M1042.55 279.391C1060.66 288.114 1110.07 300.959 1162.87 282.555",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1013.14 948.333C954.902 790.821 959.709 654.23 978.141 611.671C1041.41 658.489 1162.5 620.166 1203.53 603.607C1258.41 661.666 1210.99 972.301 1180.43 1120.36C1168.67 1139.71 1143.33 1129.77 1132.13 1122.38L1118.13 1019.56L1102.03 1109.61C1093.07 1124.66 1066.57 1121.7 1054.44 1118.34L1013.14 948.333Z",
    fill: "#BAC3D7"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M954.222 409.107C954.222 458.107 951.508 514.952 979.091 609.481C1005.52 630.729 1062.62 651.033 1200.42 603.815C1207.5 598.148 1207.08 601.435 1206.32 570.9C1205.38 532.731 1205.85 447.461 1195.93 403.607",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1317.61 425.607C1333.34 444.819 1348.95 505.257 1317.61 540.405C1286.28 575.554 1230.63 609.852 1206.72 622.607M1206.72 530.957L1247.78 486.077C1250.45 482.927 1254.85 474.644 1251.08 466.708",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1028.96 1131.09C1040.31 1131.09 1052.12 1122.64 1055.9 1118.42C1076.88 1124.21 1092.52 1119.62 1097.72 1116.61V1135.32C1084.68 1148.84 1043.85 1151.62 1026.13 1145.58C1015.5 1140.75 1019.26 1131.09 1028.96 1131.09Z",
    stroke: "#BAC3D7",
    strokeWidth: 5
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1117.54 1131.86C1124.84 1130.92 1133.22 1125.97 1136.5 1123.61C1151.67 1132.1 1167.64 1129.51 1173.72 1127.15V1137.76C1173.72 1144.84 1168.1 1146.61 1164.59 1147.79L1131.58 1157.82C1123.16 1159.98 1109.11 1161.94 1102.79 1152.51C1095.69 1141.91 1108.41 1133.04 1117.54 1131.86Z",
    stroke: "#BAC3D7",
    strokeWidth: 5
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1033.72 219.607C1056.72 207.607 1071.72 215.107 1072.22 206.107C1072.62 198.907 1062.72 198.107 1057.72 198.607C1006.52 197.807 963.722 226.107 942.222 243.107C896.222 279.479 874.889 350.274 874.222 383.607C872.889 406.94 876.922 454.107 903.722 456.107C930.522 458.107 960.5 407.607 965.722 364.607C970.945 321.607 981.771 267.507 999.082 265.107M1003.72 216.107C1016.56 215.607 1042.22 219.207 1042.22 237.607C1042.39 239.607 1041.12 243.307 1034.72 242.107M1016.72 231.107C1025.22 235.44 1040.72 246.107 1034.72 254.107C1033.56 255.774 1030.22 259.107 1026.22 259.107M1012.72 244.607C1019.56 248.274 1031.42 257.907 1024.22 267.107C1017.02 276.307 1008.89 275.607 1005.72 274.107C1002.46 272.748 997.538 269.351 999.082 265.107M1009.72 265.107C1009.39 261.774 1007.22 256.507 1001.22 262.107C1000.11 263.141 999.432 264.146 999.082 265.107",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M883.222 440.607C888.389 456.44 919.122 503.007 958.722 516.607",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M978.722 298.107C992.722 287.107 1014.62 269.207 1066.22 255.607",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M2.71191 552.5L14.7119 569.5M23.2119 569.5V549M31.7119 569.5L43.7119 549",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M348.558 1022L292.025 1001.33C291.236 1001.04 290.712 1000.29 290.712 999.452V945.255C290.712 943.952 291.937 942.997 293.199 943.315L293.341 943.351M348.558 1022V964.5M348.558 1022L384.201 982.254C384.53 981.887 384.712 981.411 384.712 980.918V929.471M348.558 964.5L293.341 943.351M348.558 964.5L384.712 929.471M293.341 943.351L328.556 907.944C329.125 907.372 329.981 907.198 330.728 907.502L384.712 929.471",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M563.712 1031.16V1077.51C563.712 1077.99 563.886 1078.46 564.202 1078.82L590.435 1109M563.712 1031.16L590.435 1057.32M563.712 1031.16L609.222 1023.89C609.845 1023.79 610.478 1023.99 610.931 1024.43L636.712 1049.47M590.435 1109V1057.32M590.435 1109L635.087 1100.47C636.03 1100.29 636.712 1099.46 636.712 1098.5V1049.47M590.435 1057.32L636.712 1049.47",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M444.712 760.5L462.712 774.5M474.212 774.5V743M486.212 774.5L499.712 754",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M663.712 716L569.712 720",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M664.712 716L788.712 727",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M789.712 727L764.712 843",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M764.712 843L661.712 861",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M661.712 860V737",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M661.712 738L788.712 728",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M661.712 738L569.712 720",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M567.712 720L573.712 812",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M573.712 812L661.712 861",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M662.712 716V736",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 707.924,
    y: 765.881,
    width: 37.2431,
    height: 19.996,
    rx: 8.5,
    transform: "rotate(-3.53924 707.924 765.881)",
    stroke: "#BAC3D7",
    strokeWidth: 3
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M532.712 583C550.341 611.048 598.526 664.175 650.238 652.296L722.712 598.839",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M532.712 583L614.712 556",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M614.712 556C630.094 570 673.228 598 722.712 598",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M578.712 597C585.823 595.333 602.179 590 610.712 582",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M599.712 615C604.156 614 614.379 610.2 619.712 603",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M623.712 628C629.379 627 644.312 622.4 650.712 608",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M660.992 887L571.212 813.5L661.212 863.5L767.212 845L777.212 846.5L660.992 887Z",
    fill: "#BAC3D7",
    fillOpacity: 0.3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOcThinking);
export default __webpack_public_path__ + "static/media/oc-thinking.c036f43ac1c85e0dc805698bf1e1478d.svg";
export { ForwardRef as ReactComponent };